import { Award } from "lucide-react";

const Since1998Badge = ({ variant = "default", size = "medium" }) => {
  if (variant === "header") {
    return (
      <div className="inline-flex items-center bg-black text-white px-3 py-1 rounded-full text-xs font-bold border border-gray-700">
        <Award className="w-3 h-3 mr-1" />
        Since 1998
      </div>
    );
  }

  if (variant === "hero") {
    return (
      <div className="inline-flex items-center bg-black text-white px-6 py-3 rounded-lg text-lg font-bold border-2 border-orange-500 shadow-xl">
        <Award className="w-5 h-5 mr-2 text-orange-500" />
        <span>America&apos;s Original FSBO Site</span>
        <span className="mx-2">•</span>
        <span className="text-orange-500">Since 1998</span>
      </div>
    );
  }

  if (variant === "compact") {
    return (
      <span className="inline-flex items-center text-xs font-semibold text-gray-600">
        <Award className="w-3 h-3 mr-1" />
        Est. 1998
      </span>
    );
  }

  // Default badge
  return (
    <div className="inline-flex items-center bg-gradient-to-r from-orange-600 to-red-600 text-white px-4 py-2 rounded-lg text-sm font-bold shadow-lg">
      <Award className="w-4 h-4 mr-2" />
      <span>Since 1998 • 27 Years Strong</span>
    </div>
  );
};

export default Since1998Badge;
